import Cropper from "cropperjs";

export default class ImageCropper {
  constructor(node) {
    this.element = node;

    this.removeImageButton = this.element.querySelector(".js-cropper-remove");
    this.imageToCrop = this.element.querySelector(".js-image");
    this.uploadImageElement = this.element.querySelector(".js-cropper-upload");
    this.inputFileElement = this.element.querySelector(".js-input-file");

    this.croppable = false;
    this.fileName = this.element.dataset.defaultFileName;
    this.cropper = null;

    const { minWidth, minHeight, resultWidth, resultHeight } = this.element.dataset;

    this.minCroppedWidth = parseInt(minWidth);
    this.minCroppedHeight = parseInt(minHeight);
    this.imageResultWidth = parseInt(resultWidth);
    this.imageResultHeight = parseInt(resultHeight);

    switch (this.element.dataset.aspectRatio) {
      case "squared":
        this.aspectRatio = 1;
        break;
      case "free":
        this.aspectRatio = NaN;
        break;
      default:
        this.aspectRatio = 16 / 9;
        break;
    }

    // We are using IntersectionObserver to initialize the cropper only when the user scrolls to the image.
    // This is to avoid initializing the cropper with incorrect dimensions.
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.initialize();
          observer.unobserve(this.element);
        }
      });
    });
    observer.observe(this.element);
  }

  initialize() {
    if (this.imageToCrop.src != "") {
      this.generateCropperInstance();
    }

    const formElement = this.element.closest("form");

    formElement.addEventListener("ajax:before-submit", () => {
      if (this.cropper === null) {
        // Incase we have no cropper instance (user has not uploaded an image or has removed the image)
        formElement.dispatchEvent(new CustomEvent("ajax:before-submit-complete"));
      } else {
        this.getCroppedImage().then(() => {
          formElement.dispatchEvent(new CustomEvent("ajax:before-submit-complete"));
        });
      }
    });

    this.uploadImageElement.addEventListener("click", () => {
      this.inputFileElement.click();
    });

    this.inputFileElement.addEventListener("change", () => {
      const file = this.inputFileElement.files;

      if (file) {
        if (this.cropper === null) {
          this.generateCropperInstance();
        }

        this.cropper.replace(URL.createObjectURL(file[0]));
        this.fileName = file[0].name;
        this.removeImageButton.classList.remove("d-none");
      }
    });

    this.removeImageButton.addEventListener("click", () => {
      this.removeImageButton.classList.add("d-none");

      this.imageToCrop.src = this.element.dataset.defaultImagePath;
      this.inputFileElement.files = null;
      this.inputFileElement.value = null;

      this.cropper.destroy();
      this.cropper = null;
    });
  }

  getCroppedImage() {
    return new Promise((resolve, reject) => {
      this.cropper.getCroppedCanvas({ width: this.imageResultWidth, height: this.imageResultHeight }).toBlob(
        (blob) => {
          const file = [new File([blob], this.fileName, { type: "image/jpeg" })];
          const container = new DataTransfer();

          container.items.add(file[0]);
          this.inputFileElement.files = container.files;

          resolve();
        },
        "image/jpeg",
        0.99
      );
    });
  }

  generateCropperInstance() {
    this.cropper = new Cropper(this.imageToCrop, {
      viewMode: 2,
      zoomable: false,
      movable: false,
      rotatable: false,
      scalable: false,
      aspectRatio: this.aspectRatio,
      guides: false,
      center: false,
      highlight: false,
      minCropBoxWidth: this.minCroppedWidth,
      minCropBoxHeight: this.minCroppedHeight,
      autoCropArea: 1,
      ready: () => {
        this.croppable = true;
      },
    });
  }
}
